import React, { useState } from "react";
import { getLocationByName, saveLocation } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import LocationNameField from "./LocationNameField";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function CreateLocationModal({ setShowModal, validationErrors, onBack }) {

    const [location, setLocation] = useState({});

    const onSaveClick = async () => {

        const serverLocation = await getLocationByName(location.name);
        let savedLocation;

        if (serverLocation.error && serverLocation.statusCode === 404) {
            savedLocation = await saveLocation(location);
        } else {
            showDangerToast(`Location with name '${location.name}' already exist`, "Save Location")
        }

        if (savedLocation) {
            showSuccessToast("Location created", "Save Location");
            setShowModal(false);
        }

    }

    return (
        <TargetTypeWizardModal
            title="Add Location Wizard"
            subtitle="Create a location target type."
            onClose={() => setShowModal(false)}
            onBack={onBack}
            onSubmit={onSaveClick}
            submitLabel="Save"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <LocationNameField location={location} setLocation={setLocation} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(CreateLocationModal);
